export default function isDiffCertain() {
	return true;
}
